<template>
  <div> {{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Consulta Facturas'" :titulo="'Consulta Facturas'"
                       @MethodAnular="anular" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo" @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
      <tr>

        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>
                    <v-btn color="deep-purple accent-2" dark small
                           @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitBancos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->

        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto "
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">
              <v-card color="grey lighten-3">

                <div class="px-2">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">

                    <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
                      <v-row class="pa-0 ma-0 py-0 my-0">

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="4" sm="4">
                          <v-combobox v-model="ConsultaFacturas.documento" :items="RDocumento" autocomplete="off" dense
                                      hide-details item-text="descripcion" label="Documentos:"
                                      outlined
                                      style="font-size: 13px;" @blur="SelctCbDocumento" @change="BuscarFactura"
                                      @focus="cargarDocumento">
                            <template v-slot:prepend>
                              <i class="fa fa-book" style="font-size: 20px;"></i>
                            </template>
                          </v-combobox>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="2" sm="2">
                          <v-text-field v-model.number="ConsultaFacturas.factura" autocomplete="off" dense hide-details
                                        label="No.Factura:" outlined placeholder=" "
                                        style="font-size: 12px;" @blur="BuscarFactura" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="3" sm="3">
                          <v-textarea v-model="ConsultaFacturas.concepto" autocomplete="off" dense hide-details
                                      label="Concepto:"
                                      outlined rows="1" style="font-size: 12px;"
                                      @blur="BuscarFactura">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="3" sm="3">
                          <v-text-field v-model="ConsultaFacturas.ncf" autocomplete="off" dense hide-details label="NCF"
                                        outlined style="font-size: 12px;" @blur="BuscarFactura">
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="4" sm="4">
                          <v-combobox v-model="ConsultaFacturas.sucursal" :items="RSucursal" autocomplete="off" dense
                                      hide-details
                                      item-text="descripcion" label="Succursal:"
                                      outlined
                                      @blur="SelctCbSucursal" @change="BuscarFactura" @focus="cargarSucursal">
                            <template v-slot:prepend>
                              <i class="fa fa-sitemap" style="font-size: 20px;"></i>
                            </template>
                          </v-combobox>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="3" sm="3">
                          <v-text-field v-model="ConsultaFacturas.desde" :rules="[$rules.required]" dense hide-details
                                        label="Fecha Desde"
                                        outlined style="font-size: 12px;" type="date"
                                        @blur="BlurDesde"
                                        @input="BuscarFactura">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="3" sm="3">
                          <v-text-field v-model="ConsultaFacturas.hasta" :rules="[$rules.required]" dense hide-details
                                        label="Fecha Hasta"
                                        outlined style="font-size: 12px;" type="date"
                                        @blur="BlurHasta"
                                        @input="BuscarFactura">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="2" sm="2">
                          <v-btn :disabled="texAria.length <= 0" color="light-blue accent-2" target="_blank"
                                 @click.prevent="ReporteImprimir">
                            <i class="fa fa-print" style="font-size: 28px;"> </i>
                            <span style="color:#FFFFFF;">Printer </span>
                          </v-btn>
                        </v-col>

                      </v-row>
                    </v-col>

                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                      <v-row class="pa-0 ma-0 py-0 my-0">

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="4" sm="4">
                          <div class="overflow-x-auto" style=" max-height:420px">
                            <v-textarea id="formdisabledInput" :rows="rowDesTab" :value="texAria" disabled solo
                                        style="font-size: 12px; font-family: monospace; white-space: pre;"></v-textarea>
                          </div>
                          <!-- <v-card style=" min-height:400px">
                            <v-card-text class="black--text">
                              {{ texAria }}
                            </v-card-text>
                          </v-card> -->
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="8" sm="8">
                          <div style="border: 1px solid #000000;">
                            <v-data-table v-model="selectedListFact" :headers="[
                                { text: 'Factura', sortable: false, value: 'fact', width: 'auto', class: ['no-gutters black--text'] },
                                { text: 'Devolución', sortable: false, value: 'idDevolucion', width: 'auto', class: ['no-gutters black--text'] },
                                { text: 'Fecha', sortable: false, value: 'fecha', width: 120, class: ['no-gutters black--text'] },
                                { text: 'Valor', sortable: false, value: 'valor', width: 'auto', class: ['no-gutters black--text'] },
                                { text: 'Comentario', sortable: false, value: 'comentario', width: 250, class: ['no-gutters black--text'] },
                                { text: 'Activo/Anulado', sortable: false, value: 'activoanulado', width: 80, class: ['no-gutters black--text'] }

                              ]"
                                          :items="listDatos" :items-per-page="15"
                                          :search="search"
                                          :show-select="true" :single-select="true"
                                          class="elevation-1 RowSelectColor TbSize13" dense item-key="indx"
                                          @item-selected="obtenerDatoSelectFact"
                                          @click:row="obtenerDatoSelectFactClickRow">

                              <template v-slot:item.fact="props">
                          <!-- {{ props.item.activada ? "" : "Anulada" }} -->
                                <span :style="{ color: props.item.activada ? 'inherit' : 'red' }">{{
                                    props.item.documentoFactura.nombrecorto + "-" + props.item.facturasventaPK.secuencia }}</span>
                              </template>

                              <template v-slot:item.idDevolucion="props">
                                <span :style="{ color: props.item.activada ? 'inherit' : 'red' }">{{props.item.idDevolucion }}</span>
                              </template>

                              <template v-slot:item.fecha="props">
                                <span :style="{ color: props.item.activada ? 'inherit' : 'red', display: 'none' }"></span>
                                <span :style="{ color: props.item.activada ? 'inherit' : 'red' }">{{ FormatoFecha(props.item.fecha) }}</span>
                              </template>

                              <template v-slot:item.valor="props">
                                <span :style="{ color: props.item.activada ? 'inherit' : 'red' }">{{  currencyFormatter(props.item.valor)}}</span>
                              </template>

                              <template v-slot:item.comentario="props">
                                <span :style="{ color: props.item.activada ? 'inherit' : 'red' }">{{props.item.comentario }}</span>
                              </template>
                              
                              <template v-slot:item.activoanulado="props">
                                <span v-if="props.item.activada==true" style="font-size: 12px"> <b class="green--text">ACTIVO</b></span>
                                <span v-if="props.item.activada==false" style="font-size: 12px"> <b class="red--text">ANULADO</b></span>
                             </template>

                            </v-data-table>
                          </div>
                        </v-col>

                      </v-row>
                    </v-col>

                  </v-form>
                </div>
              </v-card>
            </div>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->

        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            ">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------  Modal Loader -->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          <br></br>
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js"
import BarraBusqueda2 from "../components/BarraBusquedaDinam"
import ContenidoBase from "../components/ContenidoBase"
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
  },

  created() {
    var json = {
      titulo: "Consulta Facturas",
      descripcion: "Consulta Facturas",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,

      accion: [
        "ConsultaFacturasNew",
        "ConsultaFacturasSave",
        "ConsultaFacturasRemove",
        "ConsultaFacturasAnular",
        "ConsultaFacturasPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ConsultaFacturasNew", this.new);
    // EventBus.$on("ConsultaFacturasSave", this.save);
    // EventBus.$on("ConsultaFacturasRemove", this.remove);
    // EventBus.$on("ConsultaFacturasAnular", this.remove);
    // EventBus.$on("ConsultaFacturasPrintList", this.imprimirList);
    EventBus.$on("emitConsultaFacturas", this.datostabla)
    EventBus.$on("onResize", this.onResize)

    this.BuscarFactura()
  },

  data: () => ({
    listDatos: [],
    selectedListFact: [],
    RDocumento: [],
    RSucursal: [],
    ListaTiposClientes: [],
    windowSize: { width: "auto", height: "auto" },
    texAria: "",
    rowDesTab: 25,
    Reparaloading: false,
    ConsultaFacturas: {
      documento: null,
      factura: null,
      ncf: null,
      sucursal: null,
      concepto: null,
      desde: new Date().toISOString().substr(0, 10),
      hasta: new Date().toISOString().substr(0, 10),
      //fechaCreacion: new,
      //  fechaModificacion: "", 
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" },
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    aalert: {
      estado: false,
      color: null,
    },

    debounceTimer: null,
  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter, FormatoFecha, HoraFormatter, getParamFecha,
    onResize(e) {
      //this.windowSize=e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

    },

    datostabla(e) {
      this.ConsultaFacturas = e
      this.acti_tb_data = false
    },

    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    newwnuevo() {
      (this.ConsultaFacturas = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: "",
      }),
        EventBus.$emit("actualizaBarraBusqueda2")
    },

    cargarDocumento() {
      // this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioFacturaVentas/DocumentoPvFindall',{
      // usuario:JSON.parse(JSON.stringify(this.$user))
      // })
      // .then(res=>( this.RDocumento=res.data))

      this.$axios.get(this.$hostname + this.$hName + "/documentoventas/documentoFacturaVentas/", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumento = res.data))
        .catch(error => console.log(error))
    },

    SelctCbDocumento() {
      if (this.ConsultaFacturas.documento == null) {
        this.ConsultaFacturas.documento = ""
      }

      if (this.ConsultaFacturas.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.ConsultaFacturas.documento = ""
        return
      }
    },

    cargarSucursal() {
      this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RSucursal = res.data))
    },

    SelctCbSucursal() {
      if (this.ConsultaFacturas.sucursal == null) {
        this.ConsultaFacturas.sucursal = ""
      }

      if (this.ConsultaFacturas.sucursal.codigo == undefined) {
        this.alerta("Seleccione un sucursal", "error")
        this.ConsultaFacturas.sucursal = ""
        return
      }
    },

    BlurDesde() {
      if (this.ConsultaFacturas.desde.toString().length == 0) {
        this.ConsultaFacturas.desde = new Date().toISOString().substr(0, 10)
      }
    },

    BlurHasta() {
      if (this.ConsultaFacturas.hasta.toString().length == 0) {
        this.ConsultaFacturas.hasta = new Date().toISOString().substr(0, 10)
      }
    },

    BuscarFactura() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        if (this.ConsultaFacturas.factura == "" || this.ConsultaFacturas.factura == 0) {
          this.ConsultaFacturas.factura = null
        }
        var obj = JSON.parse(JSON.stringify(this.ConsultaFacturas))

        if (this.ConsultaFacturas.documento != null) {
          obj.documento = this.ConsultaFacturas.documento.codigo
        }

        if (this.ConsultaFacturas.sucursal != null) {
          obj.sucursal = this.ConsultaFacturas.sucursal.codigo
        }

        this.$axios
          .post(this.$hostname + this.$hName + "/ConsultaRapida/ConsultaFacturas", obj, { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            //this.GetDataFact(res.data)
            this.listDatos = []
            this.selectedListFact = []
            this.texAria = ""
            this.listDatos = (res.data || []).map((item, i) => ({
              ...item,
              indx: item.facturasventaPK
                ? `${item.facturasventaPK.documento}-${item.facturasventaPK.secuencia}`
                : i
            }))
          })
          .catch(error => {
            this.alerta("Reporte no Impreso(" + error + ")", "error")
          })
      }, 800)
    },

    GetDataFact(e) {
      this.listDatos = []
      this.listDatos = (e || []).map((item, i) => ({
        ...item,
        indx: item.facturasventaPK
          ? `${item.facturasventaPK.documento}-${item.facturasventaPK.secuencia}`
          : i
      }))
    },

    obtenerDatoSelectFact(e) {
      this.obtenerDatoSelectFactClickRow(e.item)
    },

    obtenerDatoSelectFactClickRow(e) {
      console.log("obtenerDatoSelectFactClickRow")

      var obj = JSON.parse(JSON.stringify(e))
      obj.horaFactura = new Date(e.horaFactura)
      this.texAria = ""

      if (e.fecha != null) {
        var fecnac = this.getParamFecha(e.fecha)
        obj.fecha = fecnac.split("T")[0]
      }

      this.selectedListFact = []
      this.selectedListFact.push(e)

      this.$axios
        .post(this.$hostname + this.$hName + "/ConsultaRapida/GetFacturas", obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.texAria = res.data, this.ver(res.data)
          console.log("obtenerDatoSelectFactClickRow-->", res.data)

        })
        .catch(error => {
        })
    },

    ver(e) {
      var au = e.split("\n").length
      this.rowDesTab = (au + 2)
    },

    ReporteImprimir() {
      if (this.selectedListFact.length == 1) {
        // this.Reparaloading=true
        EventBus.$emit("loading", true)
        var obj = JSON.parse(JSON.stringify(this.selectedListFact[0]))
        //obj.horaFactura=new Date(this.selectedListFact[0].horaFactura);
        this.$axios
          .post(this.$hostname + this.$hName + "/ConsultaRapida/ImprimirFactura", obj, { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            // this.Reparaloading=false
            EventBus.$emit("loading", false)
            setTimeout(function() {
              /*let pdfWindow = window.open("Reporte de imprecion")
              pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf'   src='data:application/pdf;base64," +
                  encodeURI(res.data) + "'></embed>")*/

              var PDF = `data:application/pdf;base64,${encodeURI(res.data)}`
              EventBus.$emit("openPDF", PDF, "Imprimir factura")
            }, 1000)
          })
          .catch(error => {
            // this.Reparaloading=false
            EventBus.$emit("loading", false)
          })
      }
    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)

        this.ejecucion = false
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
    },

    KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },
  },

  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    },
  },
}
</script>

<style></style>